/** 各フェーズ定義 */
export const PHASE = {
  INDEX_ACQUISITION: 'indexAcquisition',
  INDEX_DISPLAY: 'indexDisplay',
  DATA_ACQUISITION: 'dataAcquisition',
  DATA_RESULTS_DISPLAY: 'dataResultsDisplay',
  DATA_NON_EXISTENCE: 'dataNonExistence',
  ACQUISITION_FAILED: 'acquisitionFailed',
  COMMON_ERROR: 'commonError'
};